import { batch } from 'react-redux';
import { actions } from 'react-redux-form';
import moment from 'moment';
import { httpDownload } from "../../../../../app/utils/api.utils";
import { FILE_ATTACHMENT_MODULES } from "../../../../constants/external-constants";

import { INVOICE_STATUS } from '../../../../constants/external-constants';
import {
    invoiceDetailsFormModel,
    fetchInvoiceDetails,
    fetchInvoiceStatus,
    fetchBillingAccountNumber,
    fetchSubAccountNumber,
    fetchAssignedUser,
    setInvoiceApprovedDateRequired
} from '../../../../constants/model-reducers/external/invoice/invoice/invoice-details.settings';
import { httpGet, httpPostFile, httpPost } from '../../../../utils/api.utils';
import { convertToLocalDateToUTCDate } from '../../../../utils/helpers.utils';
import { DATE_FORMAT } from '../../../../utils/constant.utils';

export const invoiceDetailsFormInitialState = invoiceDetailsFormModel;

const defaultState = () => ({
    fetchFormInProgress: true,
    isInvoiceApprovedDateRequired: false,
    billingAccountNumberDropdown: [],
    subAccountNumberDropdown: [],
    statusDropdown: [],
    assignedUserDropdown: []
});

const initialState = defaultState();

export const invoiceDetailsAction = {
    getInvoiceDetailsForm: (invoiceId) => async (dispatch) => {
        // Status
        var statusDropdown = await getInvoiceStatus();

        dispatch({
            type: fetchInvoiceStatus,
            data: statusDropdown
        });

        if (invoiceId) {
            var data = await getInvoiceDetails(invoiceId);

            // Billing Account Number
            var billingAccountNumberDropdown = await getBillingAccountNumber();

            dispatch({
                type: fetchBillingAccountNumber,
                data: billingAccountNumberDropdown
            });

            // Assigned User
            var assignedUserDropDown = await getInvoiceAssignedUser();

            dispatch({
                type: fetchAssignedUser,
                data: assignedUserDropDown
            });

            //Sub Account Number
            var subAccountNumDropDown = await getSubAccountNumber(data.BillingAccountNumber?.AccountNumber);

            dispatch({
                type: fetchSubAccountNumber,
                data: subAccountNumDropDown
            });

            if (data) {
                batch(() => {
                    dispatch(actions.load("invoiceInvoiceDetailsForm.id", data.Id));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.billingAccountNumberId", data.BillingAccountNumber?.Id));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.billingAccountNumberDisplay", data.BillingAccountNumber?.AccountNumber));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.client", data.BillingAccountNumber?.Client));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.vendor", data.BillingAccountNumber?.Vendor));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.invoiceNumber", data.InvoiceNumber));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.currency", data.BillingAccountNumber?.Currency));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.exchangeRate", data.BillingAccountNumber?.ExchangeRate));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.remitId", data.BillingAccountNumber?.RemitId));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.apVendorId", data.BillingAccountNumber?.APVendorId));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.subAccountNumberId", data.SubAccountNumber?.Key));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.subAccountNumberDisplay", data.SubAccountNumber?.Value));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.invoiceDate", data.InvoiceDate != null ? new Date(data.InvoiceDate) : ''));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.actualInvoiceMonth", data.ActualInvoiceMonth != null ? new Date(data.ActualInvoiceMonth) : ''));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.invoiceExpectedDate", data.InvoiceExpectedDate != null ? new Date(data.InvoiceExpectedDate) : ''));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.invoiceDueDate", data.InvoiceDueDate != null ? new Date(data.InvoiceDueDate) : ''));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.invoiceApprovedDate", data.InvoiceApprovedDate != null ? new Date(data.InvoiceApprovedDate) : ''));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.billingPeriodFrom", data.BillingPeriodFrom != null ? new Date(data.BillingPeriodFrom) : ''));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.billingPeriodTo", data.BillingPeriodTo != null ? new Date(data.BillingPeriodTo) : ''));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.rentalPeriodFrom", data.RentalPeriodFrom != null ? new Date(data.RentalPeriodFrom) : ''));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.rentalPeriodTo", data.RentalPeriodTo != null ? new Date(data.RentalPeriodTo) : ''));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.invoiceReceiptDate", data.InvoiceReceiptDate != null ? new Date(data.InvoiceReceiptDate) : ''));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.assignedUserDisplay", data.AssignedUser.Value));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.assignedUserId", data.AssignedUser.Key));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.ediNumber", data.EDINumber));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.uploadDate", data.UploadDate != null ? new Date(data.UploadDate) : ''));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.uploadedBy", data.UploadedBy));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.creditNote", data.CreditNote));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.invoicePDF", data.InvoicePDF));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.invoiceAttachmentId", data.InvoiceAttachmentID));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.totalAmountDue", (data.TotalAmountDue ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.totalAmountToPay", (data.TotalAmountToPay ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.grossAmount", (data.GrossAmount ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.noOfChargedSubscription", data.NoOfChargedSubscription));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.remainingBalance", (data.RemainingBalance ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.totalTaxes", (data.TotalTaxes ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.totalNet", (data.TotalNet ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.lineItemsTotal", (data.LineItemsTotal ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.accountLevelCharges", (data.AccountLevelCharges ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.usageCharges", (data.UsageCharges ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.recurringCharges", (data.RecurringCharges ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.miscellaneousCharges", (data.MiscellaneousCharges ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.payments", (data.Payments ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.latePaymentFees", (data.LatePaymentFees ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.otherCharges", (data.OtherCharges ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.checkNumber", data.CheckNumber));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.amountPaid", (data.AmountPaid ?? 0).toFixed(2)));
                    dispatch(actions.load("invoiceInvoiceDetailsForm.paymentDate", data.PaymentDate != null ? new Date(data.PaymentDate) : ''));

                    if (data.InvoiceStatus) {
                        dispatch(actions.load("invoiceInvoiceDetailsForm.status", data.InvoiceStatus.Key));

                        var invoiceApprovedDateRequired = false;
                        if (data.InvoiceStatus.Key == INVOICE_STATUS.Processed || data.InvoiceStatus.Key == INVOICE_STATUS.ProcessedSentToAP) {
                            invoiceApprovedDateRequired = true;
                        }

                        dispatch({
                            type: setInvoiceApprovedDateRequired,
                            data: invoiceApprovedDateRequired
                        });
                    }

                    dispatch({ type: fetchInvoiceDetails, data: false });
                });

                return data;
            }
        }
    },
    searchBillingAccountNumber: (searchVal, propsName) => async (dispatch, state) => {
        const { billingAccountNumberDropdown } = state().invoiceInvoiceDetails;

        if (billingAccountNumberDropdown !== undefined && billingAccountNumberDropdown.length > 0) {
            var obj = billingAccountNumberDropdown.find(o => o[propsName] === searchVal);

            if (obj !== undefined) {
                dispatch({ type: fetchBillingAccountNumber, data: [] });
                return null;
            }
        }

        var data = await getBillingAccountNumber(searchVal);

        dispatch({
            type: fetchBillingAccountNumber,
            data: data
        });

        return data;
    },
    onChangeBillingAccountNumber: (value, propsName) => async (dispatch, state) => {
        const { billingAccountNumberDropdown } = state().invoiceInvoiceDetails;
        if (value == '' || billingAccountNumberDropdown?.length === 0) {
            batch(() => {
                resetBillingAccountNumber(dispatch);
            });
        }
        else {
            const billingAccountNumber = billingAccountNumberDropdown.find(r => r["Id"] == value);
            setBillingAccountNumber(dispatch, billingAccountNumber);

            var data = await getSubAccountNumber(billingAccountNumber.AccountNumber);

            dispatch({
                type: fetchSubAccountNumber,
                data: data
            });
        }
    },
    searchSubAccountNumber: (searchVal, propsName) => async (dispatch, state) => {
        const { invoiceInvoiceDetailsForm } = state().form;
        const { subAccountNumberDropdown } = state().invoiceInvoiceDetails;

        if (subAccountNumberDropdown !== undefined && subAccountNumberDropdown.length > 0) {
            var obj = subAccountNumberDropdown.find(o => o[propsName] === searchVal);

            if (obj !== undefined) {
                dispatch({ type: fetchSubAccountNumber, data: [] });
                return null;
            }
        }

        if (invoiceInvoiceDetailsForm.billingAccountNumberDisplay) {
            var data = await getSubAccountNumber(invoiceInvoiceDetailsForm.billingAccountNumberDisplay, searchVal);

            dispatch({
                type: fetchSubAccountNumber,
                data: data
            });
            return data;
        }
        else {
            dispatch({ type: fetchSubAccountNumber, data: [] });
            return null;
        }
    },
    onChangeSubAccountNumber: (value, propsName) => (dispatch, state) => {
        const { subAccountNumberDropdown } = state().invoiceInvoiceDetails;
        if (value == '' || subAccountNumberDropdown?.length === 0) {
            dispatch(actions.change("invoiceInvoiceDetailsForm.subAccountNumberId", invoiceDetailsFormInitialState.subAccountNumberId));
            dispatch(actions.change("invoiceInvoiceDetailsForm.subAccountNumberDisplay", invoiceDetailsFormInitialState.subAccountNumberDisplay));
        }
        else {
            const subAccountNumber = subAccountNumberDropdown.find(r => r["Key"] == value);
            if (subAccountNumber) {
                dispatch(actions.change("invoiceInvoiceDetailsForm.subAccountNumberId", subAccountNumber.Key));
                dispatch(actions.change("invoiceInvoiceDetailsForm.subAccountNumberDisplay", subAccountNumber.Value));
            }
        }
    },
    searchAssignedUser: (searchVal, propsName) => async (dispatch, state) => {
        const { assignedUserDropdown } = state().invoiceInvoiceDetails;

        if (assignedUserDropdown !== undefined && assignedUserDropdown.length > 0) {
            var obj = assignedUserDropdown.find(o => o[propsName] === searchVal);

            if (obj !== undefined) {
                dispatch({ type: fetchAssignedUser, data: [] });
                return null;
            }
        }

        var data = await getInvoiceAssignedUser(searchVal);

        dispatch({
            type: fetchAssignedUser,
            data: data
        });
        return data;
    },
    onChangeAssignedUser: (value, propsName) => (dispatch, state) => {
        const { assignedUserDropdown } = state().invoiceInvoiceDetails;
        if (value == '' || assignedUserDropdown?.length === 0) {
            batch(() => {
                resetAssignedUser(dispatch);
            });
        }
        else {
            const assignedUser = assignedUserDropdown.find(r => r["Key"] == value);
            setAssignedUser(dispatch, assignedUser);
        }
    },
    onChangeStatus: (model, value) => (dispatch) => {
        var invoiceApprovedDateRequired = false;

        batch(() => {
            dispatch(actions.change(model, value));

            if (value == INVOICE_STATUS.Processed || value == INVOICE_STATUS.ProcessedSentToAP) {
                invoiceApprovedDateRequired = true;
            }

            dispatch({
                type: setInvoiceApprovedDateRequired,
                data: invoiceApprovedDateRequired
            });
        });
    },
    downloadInvoiceFile: (invoiceID, invoiceUploadFileNameID, fileName) => async () => {

        await httpDownload('common/fileAttachment/downloadInvoiceFile/'
                + FILE_ATTACHMENT_MODULES.invoiceFileAttachment + '/'
                + invoiceID + '/'
                + invoiceUploadFileNameID + '/'
                + encodeURIComponent(fileName))
                .then(function (response) {
                    return response.blob();
                })
                .then(function (blob) {
                    let downloadUrl = window.URL.createObjectURL(blob);
                    //Hide Loading
                    let a = document.createElement('a');
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(blob, fileName);
                    } else if (typeof a.download === "undefined") {
                        window.location = downloadUrl;
                    } else {
                        a.href = downloadUrl;
                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                    }
                });
    },
    saveInvoiceForm: (invoiceId, validate, invoiceFile) => async (dispatch, state) => {
        try {
            const { form: { forms: { invoiceInvoiceDetailsForm: { $form } } } } = state();
            const { invoiceInvoiceDetailsForm } = state().form;

            var formData = new FormData();
            formData.append("InvoiceId", parseInt(invoiceId));
            formData.append("BillingAccountNumberId", parseInt(invoiceInvoiceDetailsForm.billingAccountNumberId));
            formData.append("SubAccountNumberId", invoiceInvoiceDetailsForm.subAccountNumberId != null ? parseInt(invoiceInvoiceDetailsForm.subAccountNumberId) : "");
            formData.append("InvoiceNumber", invoiceInvoiceDetailsForm.invoiceNumber);
            formData.append("StatusId", parseInt(invoiceInvoiceDetailsForm.status));
            formData.append("ActualInvoiceMonth", invoiceInvoiceDetailsForm.actualInvoiceMonth ? moment(invoiceInvoiceDetailsForm.actualInvoiceMonth).startOf('day').format('DD MMM YYYY') : "");
            formData.append("InvoiceExpectedDate", moment(invoiceInvoiceDetailsForm.invoiceExpectedDate).startOf('day').format('DD MMM YYYY'));
            formData.append("invoiceDate", moment(invoiceInvoiceDetailsForm.invoiceDate).startOf('day').format('DD MMM YYYY'));
            formData.append("InvoiceDueDate", moment(invoiceInvoiceDetailsForm.invoiceDueDate).startOf('day').format('DD MMM YYYY'));
            formData.append("InvoiceApprovedDate", invoiceInvoiceDetailsForm.invoiceApprovedDate ? moment(invoiceInvoiceDetailsForm.invoiceApprovedDate).startOf('day').format('DD MMM YYYY') : "" );
            formData.append("BillingPeriodFrom", moment(invoiceInvoiceDetailsForm.billingPeriodFrom).startOf('day').format('DD MMM YYYY'));
            formData.append("BillingPeriodTo", moment(invoiceInvoiceDetailsForm.billingPeriodTo).startOf('day').format('DD MMM YYYY'));
            formData.append("RentalPeriodFrom", moment(invoiceInvoiceDetailsForm.rentalPeriodFrom).startOf('day').format('DD MMM YYYY'));
            formData.append("RentalPeriodTo", moment(invoiceInvoiceDetailsForm.rentalPeriodTo).startOf('day').format('DD MMM YYYY'));
            formData.append("InvoiceReceiptDate", invoiceInvoiceDetailsForm.invoiceReceiptDate ? moment(invoiceInvoiceDetailsForm.invoiceReceiptDate).startOf('day').format('DD MMM YYYY') : "");
            formData.append("AssignedUserId", parseInt(invoiceInvoiceDetailsForm.assignedUserId));
            formData.append("EDINumber", invoiceInvoiceDetailsForm.ediNumber ?? '');
            formData.append("CreditNote", invoiceInvoiceDetailsForm.creditNote);
            formData.append("TotalAmountDue", parseFloat(invoiceInvoiceDetailsForm.totalAmountDue));
            formData.append("RemainingBalance", invoiceInvoiceDetailsForm.remainingBalance ? parseFloat(invoiceInvoiceDetailsForm.remainingBalance) : "");
            formData.append("Payments", invoiceInvoiceDetailsForm.payments ? parseFloat(invoiceInvoiceDetailsForm.payments) : "");
            formData.append("LatePaymentFees", invoiceInvoiceDetailsForm.latePaymentFees ? parseFloat(invoiceInvoiceDetailsForm.latePaymentFees) : "");
            formData.append("OtherCharges", invoiceInvoiceDetailsForm.otherCharges ? parseFloat(invoiceInvoiceDetailsForm.otherCharges) : "");
            formData.append("AmountPaid", invoiceInvoiceDetailsForm.amountPaid ? parseFloat(invoiceInvoiceDetailsForm.amountPaid) : "");
            formData.append("PaymentDate", invoiceInvoiceDetailsForm.paymentDate ? moment(invoiceInvoiceDetailsForm.paymentDate).startOf('day').format('DD MMM YYYY') : "");
            formData.append("CheckNumber", invoiceInvoiceDetailsForm.checkNumber ?? '');
            var removePDFFile = ($form.loadedValue.invoicePDF !== "" || $form.loadedValue.invoicePDF !== null) && (invoiceInvoiceDetailsForm.invoicePDF == "" || invoiceInvoiceDetailsForm.invoicePDF == null);
            formData.append("IsRemovePDFFile", removePDFFile);
         
            if (removePDFFile == false) {
                if (invoiceFile !== null) {
                    formData.append("File", invoiceFile);
                }
            }

            var result = await saveInvoice(validate, formData);

            if (result.success && validate == false) {
                dispatch(actions.load("invoiceInvoiceDetailsForm", invoiceInvoiceDetailsForm));
            }

            return result;
        }
        catch (e) {
            return e;
        }
    },

    deleteInvoiceForm: (invoiceId) => async (dispatch, state) => {
        try {
            var result = await deleteInvoice(invoiceId);

            return result;
        }
        catch (e) {
            return e;
        }
    },
    resetInvoiceDetailsForm: () => (dispatch) => {
        batch(() => {
            dispatch(actions.load("invoiceInvoiceDetailsForm", invoiceDetailsFormInitialState));
            dispatch(actions.reset("invoiceInvoiceDetailsForm"));
            dispatch({ type: fetchInvoiceDetails, data: true });
        })
    }
};

function resetBillingAccountNumber(dispatch) {
    dispatch(actions.change("invoiceInvoiceDetailsForm.billingAccountNumberId", invoiceDetailsFormInitialState.billingAccountNumberId));
    dispatch(actions.change("invoiceInvoiceDetailsForm.billingAccountNumberDisplay", invoiceDetailsFormInitialState.billingAccountNumberDisplay));
    dispatch(actions.change("invoiceInvoiceDetailsForm.client", invoiceDetailsFormInitialState.client));
    dispatch(actions.change("invoiceInvoiceDetailsForm.vendor", invoiceDetailsFormInitialState.vendor));
    dispatch(actions.change("invoiceInvoiceDetailsForm.currency", invoiceDetailsFormInitialState.currency));
    dispatch(actions.change("invoiceInvoiceDetailsForm.exchangeRate", invoiceDetailsFormInitialState.exchangeRate));
    dispatch(actions.change("invoiceInvoiceDetailsForm.remitId", invoiceDetailsFormInitialState.remitId));
    dispatch(actions.change("invoiceInvoiceDetailsForm.apVendorId", invoiceDetailsFormInitialState.apVendorId));

    dispatch(actions.change("invoiceInvoiceDetailsForm.subAccountNumberId", invoiceDetailsFormInitialState.subAccountNumberId));
    dispatch(actions.change("invoiceInvoiceDetailsForm.subAccountNumberDisplay", invoiceDetailsFormInitialState.subAccountNumberDisplay));
}

function setBillingAccountNumber(dispatch, billingAccountNumber) {
    if (billingAccountNumber) {
        batch(() => {
            dispatch(actions.change("invoiceInvoiceDetailsForm.billingAccountNumberId", billingAccountNumber.Id));
            dispatch(actions.change("invoiceInvoiceDetailsForm.billingAccountNumberDisplay", billingAccountNumber.AccountNumber));
            dispatch(actions.change("invoiceInvoiceDetailsForm.client", billingAccountNumber.Client));
            dispatch(actions.change("invoiceInvoiceDetailsForm.vendor", billingAccountNumber.Vendor));
            dispatch(actions.change("invoiceInvoiceDetailsForm.currency", billingAccountNumber.Currency));
            dispatch(actions.change("invoiceInvoiceDetailsForm.exchangeRate", billingAccountNumber.ExchangeRate));
            dispatch(actions.change("invoiceInvoiceDetailsForm.remitId", billingAccountNumber.RemitId));
            dispatch(actions.change("invoiceInvoiceDetailsForm.apVendorId", billingAccountNumber.APVendorId));

            dispatch(actions.change("invoiceInvoiceDetailsForm.subAccountNumberId", invoiceDetailsFormInitialState.subAccountNumberId));
            dispatch(actions.change("invoiceInvoiceDetailsForm.subAccountNumberDisplay", invoiceDetailsFormInitialState.subAccountNumberDisplay));
        })
    }
    else {
        batch(() => {
            resetBillingAccountNumber(dispatch);
        });
    }
}

function resetAssignedUser(dispatch) {
    dispatch(actions.change("invoiceInvoiceDetailsForm.assignedUserId", invoiceDetailsFormInitialState.assignedUserId));
    dispatch(actions.change("invoiceInvoiceDetailsForm.assignedUserDisplay", invoiceDetailsFormInitialState.assignedUserDisplay));
}

function setAssignedUser(dispatch, assignedUser) {
    if (assignedUser) {
        batch(() => {
            dispatch(actions.change("invoiceInvoiceDetailsForm.assignedUserId", assignedUser.Key));
            dispatch(actions.change("invoiceInvoiceDetailsForm.assignedUserDisplay", assignedUser.Value));
        })
    }
}

async function getInvoiceDetails(invoiceId) {
    try {
        var result = await httpGet(`external/invoice/details/${invoiceId ?? 0}`);

        return result.data;
    }
    catch (e) {
        return null;
    }
}

async function getBillingAccountNumber(searchVal="") {
    try {
        var result = await httpGet(`external/invoice/billing-account-number-dropdown?searchVal=${searchVal ?? ''}`);

        return result.data;
    }
    catch (e) {
        return [];
    }
}

async function getSubAccountNumber(accountNumber, searchVal="") {
    try {
        var result = await httpGet(`external/invoice/sub-account-number-dropdown/${accountNumber}?searchVal=${searchVal ?? ''}`);

        return result.data;
    }
    catch (e) {
        return [];
    }
}

async function getInvoiceStatus() {
    try {
        var result = await httpGet(`external/invoice/status-dropdown`);

        return result.data;
    }
    catch (e) {
        return [];
    }
}

async function getInvoiceAssignedUser(searchVal="") {
    try {
        var result = await httpGet(`external/invoice/assigned-user-dopdown?searchVal=${searchVal ?? ''}`);

        return result.data;
    }
    catch (e) {
        return [];
    }
}
async function saveInvoice(validate, data) {
    try {
        validate = validate ? 1 : 0;
        var result = await httpPostFile(`external/invoice/details/save/${validate}`, data);

        if (result.ok == false) {
            throw {
                success: false,
                message: "Invoice is not saved. Error encountered while on saving."
            };
        }
        return result;
    }
catch (e) {
        throw e;
    }
}

async function deleteInvoice(invoiceId) {
    try {
        const dealName = sessionStorage.getItem('DealName');
        var result = await httpPost('external/invoice/deleteInvoice/' + invoiceId);

        if (result.ok == false) {
            throw {
                success: false,
                message: "Invoice is not deleted. Error encountered while deleting."
            };
        }
        return result;
    }
    catch (e) {
        throw e;
    }
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case fetchInvoiceDetails:
            return {
                ...state,
                fetchFormInProgress: action.data
            };
        case fetchInvoiceStatus:
            return {
                ...state,
                statusDropdown: action.data
            };
        case fetchBillingAccountNumber:
            return {
                ...state,
                billingAccountNumberDropdown: action.data
            };
        case fetchSubAccountNumber:
            return {
                ...state,
                subAccountNumberDropdown: action.data
            };
        case setInvoiceApprovedDateRequired:
            return {
                ...state,
                isInvoiceApprovedDateRequired: action.data
            };
        case fetchAssignedUser:
            return {
                ...state,
                assignedUserDropdown: action.data
            };
        default:
            return state;
    } 
}